import script from "./IntentsReports.vue?vue&type=script&lang=ts&setup=true"
export * from "./IntentsReports.vue?vue&type=script&lang=ts&setup=true"

import "./IntentsReports.vue?vue&type=style&index=0&id=7079a3ce&lang=scss"
import "./IntentsReports.vue?vue&type=style&index=1&id=7079a3ce&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7079a3ce"]])

export default __exports__